export default {
  message: "We're sorry, it looks like there was an error!",
  url: 'https://toolkit.cnycn.org',
  contactMessage: 'Please contact us if you think you should not be seeing this page.',
  contactEmail: 'info@cnycn.org',
  contactPhone: '646-786-0888'
};
